import React from 'react'
import { connect } from 'react-redux'
import RegionsFilter from '../components/regions-filter'

const mapStateToProps = (state) => ({
  ...state.regionsFilter
})

const mapDispatchToProps = dispatch => ({
  onUpdate: payload => dispatch({type: 'REGIONS_FILTER.UPDATE', payload}),
  onReload: payload => dispatch({type: 'REGIONS_FILTER.RELOAD', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(RegionsFilter)
